import { SessionTimeoutService } from "@noted/helper-functions";
import { ReactNode, useCallback, useEffect, useMemo, useState } from "react";

import { useMeQuery } from "~/api/me/use-me-query";

export type SessionTimeoutStates = "NONE" | "WARNING" | "EXPIRED";

type AuthTimeoutHandlerProps = {
  children: ({
    state,
  }: {
    state: SessionTimeoutStates;
    renewSessionTime: SessionTimeoutService["renewSessionTime"];
  }) => ReactNode;
};

function AuthTimeoutHandler({ children }: AuthTimeoutHandlerProps) {
  const { data } = useMeQuery();
  const timeoutInMinutes = data?.organisation?.sessionTimeout ?? 120;

  const timeoutService = useMemo(
    () => new SessionTimeoutService(timeoutInMinutes * 60, 10),
    [timeoutInMinutes]
  );
  const [state, setState] = useState<SessionTimeoutStates>("NONE");

  const renewSessionTime = useCallback(() => {
    timeoutService.renewSessionTime();
    setState("NONE");
  }, [timeoutService, setState]);

  useEffect(() => {
    timeoutService.registerWarningFunction(() => setState("WARNING"));
    timeoutService.registerExpiredFunction(() => setState("EXPIRED"));

    timeoutService.start(window.setInterval);
    return () => timeoutService.stop(window.clearInterval);
  }, [timeoutService, setState]);

  return children({ state, renewSessionTime });
}

export default AuthTimeoutHandler;
